module.exports = __webpack_public_path__ + "static/c1-bf4ba610f6decfa7f405506b8485b4cc.png";